export enum NavigationEvents {
  PAGE_VIEW = "navigation_page_view",
  SIDEBAR_CLICK = "navigation_sidebar_click",
  BREADCRUMB_CLICK = "navigation_breadcrumb_click",
  ROUTE_CHANGE = "navigation_route_change",
  LINK_CLICKED = "navigation_link_clicked",
  TAB_CHANGED = "navigation_tab_changed",
}
